var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserProfile = function SvgUserProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 11.8a4.2 4.2 0 1 1 .001 8.399A4.2 4.2 0 0 1 24 11.8m0 18c5.94 0 12.2 2.92 12.2 4.2v2.2H11.8V34c0-1.28 6.26-4.2 12.2-4.2M24 8c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8m0 18c-5.34 0-16 2.68-16 8v6h32v-6c0-5.32-10.66-8-16-8"
  })));
};
export default SvgUserProfile;